import type UserMlsRoster from '@bb/domain/dist/types/UserMlsRoster';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const findOneRosterQa = async ({
  boardId,
  mlsNumber,
  mlsUniqueId,
  rosterType,
}: {
  boardId?: string;
  mlsNumber?: string;
  mlsUniqueId?: string;
  rosterType:
    | 'usermlsroster'
    | 'usermlsrosterinactive'
    | 'usermlsrosternonagent';
}) => {
  const searchParams = new URLSearchParams({
    ...(boardId && { boardId }),
    ...(mlsNumber && { mlsNumber }),
    ...(mlsUniqueId && { mlsUniqueId }),
    rosterType,
  });
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `/roster/qa_page?${searchParams.toString()}`,
  };

  const { data } = await axios.request<UserMlsRoster>(config);

  return data;
};

export default findOneRosterQa;
